export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_ALTERNATIVE_RECO = 'altreco'; // [Alt]ernative [Reco]mmendation source
export const HYDRA_BROOKS_VIDEO = 'brovid'; // [Bro]oks [Vid]eo on pdp for select products and styles

export const HYDRA_BELOW_ADD_TO_CART_SLOT = 'batc'; // [B]elow [A]dd [T]o [C]art Slot
export const HYDRA_SEPHORA_PAGE = 'seph'; // [SEPH]ora Page;
export const HYDRA_CC_VERIFY = 'crv'; // [Cr]edit Card [V]erify
export const HYDRA_SPLIT_SHIPMENTS = 'ssp'; // [S]plit [S]hi[p]ments
export const HYDRA_CHECKOUT_PRE_ADDRESS_PROMO = 'papr'; // [P]re-[A]ddress [PR]omo
export const HYDRA_BEST_GUESS = 'gbfy'; // [G]uess [B]est [F]or [Y]ou
export const HYDRA_VIP_ENROLLMENT_AT_CHECKOUT = 'vec'; // [V]ip [E]nrollment at [C]heckout
export const HYDRA_VIP_EMAIL_SUBSCRIPTIONS = 'ves'; // [V]ip [E]mail [S]ubscriptions
export const HYDRA_SEARCH_PRODUCT_HOVER = 'sph'; // [S]earch [P]roduct [H]over
export const HYDRA_PRODUCT_GRID_IMAGES = 'pgi'; // [P]roduct [G]rid [I]mages
export const HYDRA_WEAR_IT_WITH_BUY_BOX = 'wibb'; // [W]ear [I]t with [B]uy [B]ox
export const HYDRA_HOMEPAGE_PERSONALIZATION_TEST = 'hppt'; // [H]ome[P]age [P]ersonalization [T]est; pronounced as its spelt.
export const HYDRA_RECO_DRAWER = 'recd'; // [REC]o [D]rawer
export const HYDRA_SEARCH_AUTOCOMPLETE_SEGMENTS = 'acrtf'; // [A]uto[C]omplete [R]anking [T]est [F] - matches backend test name
export const HYDRA_SORT_STYLES_BY_INVENTORY = 'ssbi'; // [S]ort [S]tyles [B]y [I]nventory
export const HYDRA_PDP_FULL_WIDTH_PROJECT = 'pfwp'; // [P]dp [F]ull [W]idth [P]roject
export const HYDRA_COLOR_LEGEND_PDP = 'cold'; // [C]ol[O]r [L]egen[D]
export const HYDRA_BRAND_INFLUENCER_SHOP_THE_LOOK_SEARCH = 'biss'; // [B]rand [I]nfluencer [S]hop the Look on [S]earch
export const HYDRA_BRAND_INFLUENCER_SHOP_THE_LOOK_PDP = 'bisp'; // [B]rand [I]nfluencer [S]hop the Look on [P]roduct detail page
export const HYDRA_PHOTO_ANGLES = 'pang'; // [P]hoto [ANG]les
export const HYDRA_SHIPPING_RANGE_DATES = 'srd'; // [S]hipping [R]ange [D]ates
export const HYDRA_CANT_FIND_YOUR_SIZE = 'cfizz'; // [C]ant [FI]nd your si[Z]e
export const HYDRA_CATEGORY_REDIRECT_TEST = 'ctrt'; // [C]a[T]egory [R]edirect [T]est
export const HYDRA_HASHTAG = 'htag'; // [H]ash [Tag]
export const HYDRA_PARTIAL_IMAGE_GALLERY = 'ppig'; // [P]DP [P]artial [I]mage [G]allery
export const HYDRA_CTA_ON_SEARCH = 'cta1'; // [CTA] on search
export const HYDRA_PERCENT_OFF_PLACEMENT = 'poff'; // [P]ercent] [OFF] Placement
export const HYDRA_FOLLOW = 'folw'; // [Fol]lo[w] button added
export const HYDRA_STICKY_ADD_INFO = 'stain'; // [St]icky [A]dd [In]fo on PDP
export const HYDRA_HEY_DUDE_BRAND_PAGE = 'hdbp'; // [H]ey [D]ude [B]rand [P]age
export const HYDRA_SEPHORA_RETURNS = 'sret'; // [S]ephora [Ret]urns
export const HYDRA_PRODUCT_MOBILE_INFO_ABOVE = 'pmia'; // [P]roduct [M]obile [I]nfo [A]bove
export const HYDRA_SWATCHES_TERM_SORT = 'stsi'; // [S]watches [T]erm [S]ort [I]mprovement
export const HYDRA_LIKE_POST = 'lib'; // [LI]ke [B]utton
export const HYDRA_HIDE_PAYPAL = 'hpp'; // [H]ide [P]ay[P]al
export const HYDRA_SEARCHBAR_DROP_DOWN = 'sbdd'; // [S]earch[b]ar [D]rop[d]own
export const HYDRA_CUSTOMER_EXPERIENCE_ORDER_SUMMARY = 'cxos'; // [C]ustomer E[x]perience [O]rder
export const HYDRA_SIZE_CHART_CAROUSEL = 'scar'; // [S]ize [C]hart C[a][r]ousel
export const HYDRA_SHIPPING_ADDRESS_NEW_WORKFLOW = 'sanw'; // [S]hipping [A]ddress [N]ew [W]orkflow
export const HYDRA_PRODUCT_SIZING_PREDICTION = 'sped'; // [S]izing [P]rediction [E]xperience [D]iscoverability
export const HYDRA_INFLUENCER_STYLE_FEED = 'isf'; // [I]nfluencer [S]tyle [F]eed
export const HYDRA_VIP_CHECKBOX_NON_ENROLLMENT = 'vcne'; // [V]IP [C]heckbox [N]on-[E]nrollment
export const HYDRA_SEPHORA_BEAUTY_INSIDER = 'sbiz'; // [S]ephora [B]eauty [I]nsider on [Z]appos
export const HYDRA_PRODUCT_TYPE_CLASSIFIER_TEST = 'ptct'; // [P]roduct [T]ype [C]lassifier [T]est
export const HYDRA_NDA_NO_MORE_VIP = 'nnmv'; // [N]DA [N]o [M]ore for [V]IP
export const HYDRA_NEW_SWATCHES = 'nswch'; // [N]ew [SW]at[CH]es
export const HYDRA_DOVE_ADS = 'dove'; // [Dove] Sponsored Ads
export const HYDRA_MAFIA_AKAMAI = 'maka'; // [M]afia behind [Aka]mai
export const HYDRA_ZAPPOS_REDESIGN = 'zapr'; // [ZAP]pos [R]edesign
export const HYDRA_PRODUCT_CARD_LOW_STOCK = 'pcls'; // [P]roduct [C]ard [L]ow [S]tock

// Vrsnl
export const HYDRA_VRSNL_PDP = 'vpdp'; // [V]rsnl [P]roduct [D]etail [P]age
